// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a1c79214","732":"2b6c75fb","977":"414168ff"}[chunkId] + ".chunk.js";
};